import { isMobileWidth, isTabletWidth, useWindowDimensions } from '../util/util'

const useFontSize = () => {
  const viewPortWidth = useWindowDimensions()
  const isLarge = viewPortWidth > 1024
  return isLarge ? fontDesktop : fontMobile
}

export const useIsMobile = () => {
  const viewPortWidth = useWindowDimensions()
  const isMobile = isMobileWidth(viewPortWidth)
  return isMobile
}

export const useIsTablet = () => {
  const viewPortWidth = useWindowDimensions()
  return isTabletWidth(viewPortWidth)
}

const fontMobile = {
  headerSize: 24,
  subHeaderSize: 18,
  textSize: 14,
  subHeaderLineHeight: 28,
  textLineHeight: 20,
  circleHeading: 24,
  circleHeadingLineHeight: 34,
  headerLineHeight: 30,
  fontSizeSmall: 12,
}

const fontDesktop = {
  headerSize: 48,
  subHeaderSize: 24,
  textSize: 18,
  subHeaderLineHeight: 36,
  textLineHeight: 30,
  circleHeading: 44,
  circleHeadingLineHeight: 50,
  headerLineHeight: 66,
  fontSizeSmall: 14,
}

export default useFontSize
